<h1 mat-dialog-title>Untersuchungsmaterialien auswählen</h1>
<div mat-dialog-content>
    <mat-form-field style="min-width: 300px">
        <mat-select
            placeholder="Untersuchungsmaterialien auswählen"
            [formControl]="materialienCtrl"
            [compareWith]="materialienComparator"
            required
            multiple
        >
            <mat-option *ngFor="let m of materialien" [value]="m">{{ m.bezeichnung_tierart }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div mat-dialog-actions align="end">
    <button mat-stroked-button (click)="reset()" [disabled]="materialienCtrl.value?.length < 1"> Filter leeren </button>
    <span class="spacer"></span>
    <button mat-button (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="submit()">Filtern</button>
</div>
